import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Main.vue"),
    children: [
      {
        path: "/",
        name: "login",
        component: () => import("@/views/Home.vue"),
      },
      {
        path: "register",
        name: "register",
        component: () => import("@/views/Register.vue"),
      },
    ],
  },
  {
    path: "/dashboard",
    component: () => import("@/layouts/Dashboard.vue"),
    beforeEnter: (to, from, next) => {
      // ...
      if (localStorage.getItem("token")) {
        next();
      } else {
        next("/");
      }
    },
    children: [
      {
        path: "/",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
      },
      {
        path: "/notifications",
        name: "notifications",
        component: () => import("@/views/Notifications.vue"),
      },
      {
        path: "/requests",
        name: "requests",
        component: () => import("@/views/Requests.vue"),
      },
      {
        path: "/requests/new",
        name: "create-requests",
        component: () => import("@/views/CreateRequest.vue"),
      },
      {
        path: "/scan-types",
        name: "scan-types",
        component: () => import("@/views/ScanTypes.vue"),
      },
      {
        path: "/doctors",
        name: "doctors",
        component: () => import("@/views/Doctors.vue"),
      },
      {
        path: "/patients",
        name: "patients",
        component: () => import("@/views/Patients.vue"),
      },
      {
        path: "/doctor/:id/request",
        name: "create-doctor-request",
        component: () => import("@/views/CreateRequest.vue"),
      },
      {
        path: "/requests/:id",
        name: "doctor-requests",
        component: () => import("@/views/DoctorRequests.vue"),
      },
      {
        path: "/requests/details/:id",
        name: "request-details",
        component: () => import("@/views/RequestDetails.vue"),
      },
      {
        path: "/teeth",
        name: "teeth",
        component: () => import("@/views/Teeth.vue"),
      },
      {
        path: "/teeth/create",
        name: "create-teeth",
        component: () => import("@/components/CreateTeeth.vue"),
      },
      {
        path: "/branches-zones",
        name: "branches-zones",
        component: () => import("@/views/BranchesZones.vue"),
      },
      {
        path: "/doctor-ranks",
        name: "doctor-ranks",
        component: () => import("@/views/DoctorRanks.vue"),
      },
      {
        path: "/redeem-requests",
        name: "redeem-requests",
        component: () => import("@/views/RedeemRequests.vue"),
      },
      {
        path: "/redeem-instructions",
        name: "redeem-instructions",
        component: () => import("@/views/RedeemInstructions.vue"),
      },
      {
        path: "/permissions",
        name: "permissions",
        component: () => import("@/views/Permissions.vue"),
      },
      {
        path: "/permissions/role/create",
        name: "create-role-permissions",
        component: () => import("@/views/Role.vue"),
      },
      {
        path: "/permissions/role/:role_id/edit",
        name: "edit-role-permissions",
        component: () => import("@/views/Role.vue"),
      },
    ],
  },
  {
    path: "/messenger",
    component: () => import("@/views/Messenger.vue"),
    beforeEnter: (to, from, next) => {
      // ...
      if (localStorage.getItem("token")) {
        next();
      } else {
        next("/");
      }
    },
    children: [
      {
        path: "",
        name: "messenger",
        component: () => import("@/views/StartChat.vue"),
      },
      {
        path: ":roomId/chat",
        name: "chat",
        component: () => import("@/views/Chat.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
